export enum DashboardType {
  STANDARD = 'standart', // Yes, it's not a typo.
  INSIGHT = 'insight',
  ATA_DASHBOARD = 'ata_dashboard',
}
